/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_SwaggerInputs */

const en_svchip_swagger = /** @type {(inputs: Svchip_SwaggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swagger`)
};

const ar_svchip_swagger = /** @type {(inputs: Svchip_SwaggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سواقر`)
};

const bn_svchip_swagger = /** @type {(inputs: Svchip_SwaggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swagger`)
};

const de_svchip_swagger = /** @type {(inputs: Svchip_SwaggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prahlerei`)
};

const es_svchip_swagger = /** @type {(inputs: Svchip_SwaggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrogancia`)
};

const fr_svchip_swagger = /** @type {(inputs: Svchip_SwaggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fanfaronnade`)
};

const pt_svchip_swagger = /** @type {(inputs: Svchip_SwaggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrogância`)
};

const zh_svchip_swagger = /** @type {(inputs: Svchip_SwaggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招摇`)
};

const tr_svchip_swagger = /** @type {(inputs: Svchip_SwaggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Havalı`)
};

const ru_svchip_swagger = /** @type {(inputs: Svchip_SwaggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Суэггер`)
};

const pl_svchip_swagger = /** @type {(inputs: Svchip_SwaggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przechwałka`)
};

/**
* | output |
* | --- |
* | "Swagger" |
*
* @param {Svchip_SwaggerInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_swagger = /** @type {((inputs?: Svchip_SwaggerInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_SwaggerInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_swagger(inputs)
	if (locale === "bn") return bn_svchip_swagger(inputs)
	if (locale === "de") return de_svchip_swagger(inputs)
	if (locale === "es") return es_svchip_swagger(inputs)
	if (locale === "fr") return fr_svchip_swagger(inputs)
	if (locale === "pt") return pt_svchip_swagger(inputs)
	if (locale === "zh") return zh_svchip_swagger(inputs)
	if (locale === "tr") return tr_svchip_swagger(inputs)
	if (locale === "ru") return ru_svchip_swagger(inputs)
	if (locale === "pl") return pl_svchip_swagger(inputs)
	return en_svchip_swagger(inputs)
});